import styled from "styled-components";

export const SiriDimentionWrapper = styled.section`
        width:100%;
        padding:3rem 3rem 0.8rem 3rem;
        min-height: calc(100vh - 7rem);
        display:flex;
        flex-direction:column;
        @media(max-width:740px){
            padding: 65px 16px 5px 16px;
        }
`;
export const SiriDimentionCard = styled.section`
        background: #FFFFFF;
        border: 0.1rem solid #118ACB;
        border-radius: 0.6rem;
        padding:0.8rem 1.6rem 0.8rem 0.8rem;
        flex:1;   
        @media(max-width: 740px){
            padding-top: 48px;
        }
`;
export const NumberWrapper = styled.section`
                gap:1.4rem;
                align-items:center;
                display:flex;
`
export const Number = styled.div`
    display:inline-flex;
    justify-content:center;
    align-items:center;
    background: linear-gradient(91.83deg, #118ACB 12.22%, #0473AE 100.41%);
    border-radius: 0.6rem;
    color:#fff;
    font-weight: 500;
    font-size: 1.6rem;
    width:4.8rem;
    height:4.8rem;
    @media(max-width:740px){
        font-size:12px;
        width:32px;
        height:32px;
    }
`
export const NumberTextWrapper = styled.div`
    .dull-title{
        font-size: 1.2rem;
        color:#7D868C;
        margin-bottom: 0.7rem;
        @media(max-width:740px){
            font-size:10px;
            margin-bottom: 4px;
        }
    }
    .title{
        font-weight: 500;
        font-size: 1.6rem;
        color:#4D4D4F;
        @media(max-width:740px){
            font-size:14px;
        }
    }
`
export const Status = styled.div`
      display:inline-flex;
      padding:0.3rem 1rem;
      font-weight: 600;
      font-size: 1.1rem;
      background: #FFFFFF;
      text-transform:uppercase;
      color:${({ status }) => status === 'inprogress' ? '#EF6C00' : status === 'validated' ? '#4CAF50' : '#F1B1BB'};
      border: 0.1rem solid ${({ status }) => status === 'inprogress' ? 'rgba(239, 108, 0, 0.6)' : status === 'validated' ? 'rgba(76, 175, 80, 0.6)' : '#F1B1BB'};
      border-radius: 2.5rem;
`
export const Column1 = styled.section`
             display: flex;
             align-items:${({ align = 'flex-start' }) => align};
             width:32.9rem;
             padding-right:1rem;
             border-bottom:0.1rem solid ${({ borderBottom }) => borderBottom ? '#E6E6E6' : 'transparent'};
             .col-m1{
                width:9.6rem;
             }
             .col-m2{
                flex:1;
             }
`
export const Column2 = styled.section`
             flex:1;
             border-bottom:0.1rem solid ${({ borderBottom }) => borderBottom ? '#E6E6E6' : 'transparent'};
             align-items:${({ align = 'flex-start' }) => align};
             display: flex;
             .col-m1{
                flex:1;
             }
             .col-m2{
                width:20rem;
                display:flex;
                gap:3rem;
                @media(max-width:740px){
                    gap:11px;
                    width:100px;
                 }
             }
`
export const Column3 = styled.section`
             width:18.7rem;
             border-bottom:0.1rem solid ${({ borderBottom }) => borderBottom ? '#E6E6E6' : 'transparent'};
             align-items:${({ align = 'flex-start' }) => align};
             display: flex;
             position:relative;
`
export const Row = styled.section`
             min-height:3.9rem;
             display:flex;
             position:relative;
             color: #7D868C;
             .header-col-title{
                font-size: 1.2rem;
                color:inherit
                text-transform:uppercase;
                @media(max-width:740px){
                    font-size:10px;
                }
             }
             @media(max-width:992px){
                ${Column3}{
                    display:none;
                }
                ${Column1}{
                    width:20rem;
                    .col-m2{
                        display:none;
                    }
                }
            }
            @media(max-width:740px){
                ${Column1}{
                    width:68px;
                }
            }
`
export const ValidateBtn = styled.button`
             background: #43A047;
             border: 0.1rem solid #43A047;
             border-radius: 0.4rem;
             color:#fff;
             font-weight: 500;
             font-size: 1.6rem;
             padding:1rem 1.5rem;
             position:absolute;
             top:50%;
             right:0rem;
             transform:translateY(-50%);
             width:max-content;
             white-space:nowrap;
             z-index:1;
            @media(max-width:740px){
                font-size:14px;
                padding:10px 16px;
                top:0;
                transform:unset;
                span{
                    display:none;
                }
            }
`
export const ReValidateBtn = styled.button`
             background: #E5F0FF;
             border: 0.1rem solid #118ACB;
             border-radius: 0.4rem;
             color:#118ACB;
             font-weight: 500;
             font-size: 1.6rem;
             padding:1rem 1.5rem;
             position:absolute;
             top:50%;
             right:0rem;
             transform:translateY(-50%);
             width:max-content;
             white-space:nowrap;
             z-index:1;
             @media(max-width:740px){
                font-size:14px;
                padding:10px 16px;
                top:0;
                transform:unset;
                span{
                    display:none;
                }
            }
`
export const TBodyRow = styled.div`
                 width:100%;
                 .col-m1{
                    padding-right:10rem;
                    @media(max-width:740px){
                        padding-right:5px;
                    }
                 }
                 
`
export const TBodyCol = styled.div`
                 min-height:5.6rem;
                 align-items:center;
                 display:flex;
                 width:100%;
                 color: #4D4D4F;
                 font-size: 1.2rem;
                 border-bottom:0.1rem solid ${({ borderBottom }) => borderBottom ? '#E6E6E6' : 'transparent'};
                 .col-m2{
                    position:relative;
                 }
                 .sm-edited-txt{
                    display:none;
                    font-size:8px;
                    @media(max-width:992px){
                        display:inline;
                    }
                 }
                 .edited-txt{
                    position:absolute;
                    top:50%;
                    left:-2rem;
                    transform:translateY(-50%) translateX(-100%);
                    @media(max-width:992px){
                        display:none;
                    }
                 }
                 .originally-txt{
                    position:absolute;
                    top:50%;
                    right:-2rem;
                    transform:translateY(-50%) translateX(100%);
                    @media(max-width:992px){
                        display:none;
                    }
                 }
                 @media(max-width:740px){
                    min-height:36px;
                    font-size:10px;
                 }
`
export const CapabilityBtn = styled.button`
             padding:0.5rem;
             min-width:8.3rem;
             min-height:3.2rem;
             font-size: 1.2rem;
             border-radius:0.4rem;
             display:inline-flex;
             align-items:center;
             justify-content:center;
             background:#F0F0F0;
             color:#4D4D4F;
             &.active{
                background:linear-gradient(91.83deg, #118ACB 12.22%, #0473AE 100.41%);
                color:#fff;
             }
             &.inactive{
                background:#7D868C;
                color:#fff;
             }
             @media(max-width:740px){
                font-size:8px;
                padding:4px;
                min-width:44px;
                min-height:17px;
             }
`;
export const BodyRow = styled.section`
             min-height:3.9rem;
             display:flex;
             position:relative;
             color: #7D868C;
             .header-col-title{
                font-size: 1.2rem;
                color:inherit
                text-transform:uppercase;
                @media(max-width:740px){
                    font-size:10px;
                 }
             }
             .sm-text{
                display:none;
                &.turncate{
                    width:100%;
                    white-space:nowrap;
                    text-overflow: ellipsis;
                    overflow:hidden;
                }
             }
             
            @media(max-width:992px){
                ${Column3}{
                    display:none;
                }
                ${Column1}{
                    width:20rem;
                    .md-text,.col-m2{
                        display:none;
                     }
                    .sm-text{
                        display:block;
                     }
                }
            }
            @media(max-width:740px){
                ${Column1}{
                    width:68px;
                    .col-m1{
                        width:inherit;
                     }
                }
            }
`
export const Header = styled.section`
  ${Row}{
    flex-wrap:wrap;
    ${Column1}{
        @media(max-width:740px){
            padding-right:115px;
            width:100%;
            margin-bottom:8px;
        }
    }
  }
`;
// popup and mobile header css
export const SiriMobileTitleContainer = styled.div`
    display: none;
    padding: 8px 12px;
    align-items: center;
    background: #E5F0FF;
    position: fixed;
    top: 68px;
    height: 48px;
    left: 0;
    width: 100%;
    z-index: 2;
    .back-icon{
        border: 0;
        box-shadow: unset;
        height: 24px;
        width: 24px;
    }
    .back-icon:focus{
        outline: 0;
    }
    span{
        display: inline-block;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        letter-spacing: 0.02em;
        color: #0D2C54;
    }
    @media(max-width: 740px){
        display: flex;
    }

`
export const ValidatePopWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: rgba(125, 134, 140, 0.3);
    z-index: 99;
`
export const ValidatePopWrap = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    @media(max-width: 740px){
        width: calc(100% - 16px);
    }

`
export const ValidatePopCard = styled.div`
    background: #FFFFFF;
    border: 0.1rem solid #118ACB;
    box-shadow: 0px 0px 0.8rem rgba(21, 27, 38, 0.12);
    border-radius: 0.6rem;
    padding: 4.4rem 2.4rem;
    min-width: 63rem;
    @media(max-width: 740px){
        min-width: unset;
        width: 100%;
        padding: 24px 12px;
    }
    h3{
        font-weight: 500;
        font-size: 1.8rem;
        line-height: 2.8rem;
        color: #0D2C54;
        text-align: center;
        margin-bottom: 1.6rem;
        @media(max-width: 740px){
            font-size: 14px;
            line-height: 28px;
        }
    }
    p{
        font-weight: 500;
        font-size: 1.6rem;
        line-height: 2.2rem;
        color: #4D4D4F;
        margin-bottom: 4rem;
        text-align: center;
        @media(max-width: 740px){
            font-size: 14px;
            line-height: 22px;
        }
    }
`
export const ButtonWrap = styled.div`
    display: flex;
    justify-content: center;

    .cancel-btn{
        font-weight: 500;
        font-size: 1.5rem;
        min-width: 15rem;
        min-height: 4.4rem;
        background: transparent;
        color: #118acb;
        border-radius: 0.4rem;
        border: 0.1rem solid #118acb;
        margin-right: 1.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        @media(max-width: 740px){
            font-size: 12px;
            line-height: 26px;
            min-width: 88px; 
            height:44px;
            margin-right: 16px;
        }
    }
    .validate-btn{
        font-weight: 500;
        font-size: 1.5rem;
        min-width: 15rem;
        min-height: 4.4rem;
        background: #118ACB;
        border-radius: 0.4rem;
        border: 0.1rem solid #118acb;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        @media(max-width: 740px){
            font-size: 12px;
            line-height: 26px;
            min-width: 120px; 
            height: 44px;
        }
    }

`
